const countryCodes = {
  aw: '297',
  af: '93',
  ao: '244',
  ai: '1-264',
  ax: '35818',
  al: '355',
  ad: '376',
  ae: '971',
  ar: '54',
  am: '374',
  as: '1-684',
  tf: '262',
  ag: '1-268',
  au: '61',
  at: '43',
  az: '994',
  bi: '257',
  be: '32',
  bj: '229',
  bq: '599',
  bf: '226',
  bd: '880',
  bg: '359',
  bh: '973',
  bs: '1-242',
  ba: '387',
  bl: '590',
  by: '375',
  bz: '501',
  bm: '1-441',
  bo: '591',
  br: '55',
  bb: '1-246',
  bn: '673',
  bt: '975',
  bv: '47',
  bw: '267',
  cf: '236',
  ca: '1',
  cc: '61',
  ch: '41',
  cl: '56',
  cn: '86',
  ci: '225',
  cm: '237',
  cd: '243',
  cg: '242',
  ck: '682',
  co: '57',
  km: '269',
  cv: '238',
  cr: '506',
  cu: '53',
  cw: '599',
  cx: '61',
  ky: '1-345',
  cy: '357',
  cz: '420',
  de: '49',
  dj: '253',
  dm: '1-767',
  dk: '45',
  do: '1-809',
  dz: '213',
  ec: '593',
  eg: '20',
  er: '291',
  eh: '212',
  es: '34',
  ee: '372',
  et: '251',
  fi: '358',
  fj: '679',
  fk: '500',
  fr: '33',
  fo: '298',
  fm: '691',
  ga: '241',
  gb: '44',
  ge: '995',
  gg: '44-1481',
  gh: '233',
  gi: '350',
  gn: '224',
  gp: '590',
  gm: '220',
  gw: '245',
  gq: '240',
  gr: '30',
  gd: '1-473',
  gl: '299',
  gt: '502',
  gf: '594',
  gu: '1-671',
  gy: '592',
  hk: '852',
  hn: '504',
  hr: '385',
  ht: '509',
  hu: '36',
  id: '62',
  im: '44-1624',
  in: '91',
  io: '246',
  ie: '353',
  ir: '98',
  iq: '964',
  is: '354',
  il: '972',
  it: '39',
  jm: '1-876',
  je: '44-1534',
  jo: '962',
  jp: '81',
  kz: '76',
  ke: '254',
  kg: '996',
  kh: '855',
  ki: '686',
  kn: '1-869',
  kr: '82',
  kw: '965',
  la: '856',
  lb: '961',
  lr: '231',
  ly: '218',
  lc: '1-758',
  li: '423',
  lk: '94',
  ls: '266',
  lt: '370',
  lu: '352',
  lv: '371',
  mo: '853',
  mf: '590',
  ma: '212',
  mc: '377',
  md: '373',
  mg: '261',
  mv: '960',
  mx: '52',
  mh: '692',
  mk: '389',
  ml: '223',
  mt: '356',
  mm: '95',
  me: '382',
  mn: '976',
  mp: '1-670',
  mz: '258',
  mr: '222',
  ms: '1-664',
  mq: '596',
  mu: '230',
  mw: '265',
  my: '60',
  yt: '262',
  na: '264',
  nc: '687',
  ne: '227',
  nf: '672',
  ng: '234',
  ni: '505',
  nu: '683',
  nl: '31',
  no: '47',
  np: '977',
  nr: '674',
  nz: '64',
  om: '968',
  pk: '92',
  pa: '507',
  pn: '64',
  pe: '51',
  ph: '63',
  pw: '680',
  pg: '675',
  pl: '48',
  pr: '1-787',
  kp: '850',
  pt: '351',
  py: '595',
  ps: '970',
  pf: '689',
  qa: '974',
  re: '262',
  ro: '40',
  ru: '73',
  rw: '250',
  sa: '966',
  sd: '249',
  sn: '221',
  sg: '65',
  gs: '500',
  sh: '290',
  sj: '47',
  sb: '677',
  sl: '232',
  sv: '503',
  sm: '378',
  so: '252',
  pm: '508',
  rs: '381',
  ss: '211',
  st: '239',
  sr: '597',
  sk: '421',
  si: '386',
  se: '46',
  sz: '268',
  sx: '1-721',
  sc: '248',
  sy: '963',
  tc: '1-649',
  td: '235',
  tg: '228',
  th: '66',
  tj: '992',
  tk: '690',
  tm: '993',
  tl: '670',
  to: '676',
  tt: '1-868',
  tn: '216',
  tr: '90',
  tv: '688',
  tw: '886',
  tz: '255',
  ug: '256',
  ua: '380',
  um: '268',
  uy: '598',
  us: '1',
  uz: '998',
  va: '379',
  vc: '1-784',
  ve: '58',
  vg: '1-284',
  vi: '1-340',
  vn: '84',
  vu: '678',
  wf: '681',
  ws: '685',
  ye: '967',
  za: '27',
  zm: '260',
  zw: '263',
}

export default countryCodes
